import React from "react";

import AddPlayerModal from "./AddPlayerModal";
import Player from "./Player";

const Players = ({
  addPlayerHandler,
  removePlayerHandler,
  players,
  balls,
  limits,
}) => {
  const _players = _getPlayers();
  function _getPlayers() {
    const resultPlayers = players?.map(({ balls, amount, id }, index) => (
      <Player
        key={index}
        index={index + 1}
        id={id}
        cancelHandlerClick={removePlayerHandler}
        balls={balls}
        bet={amount}
        shouldCanRemove
      />
    ));
    return resultPlayers;
  }

  function _onSubmit(value) {
    addPlayerHandler(value);
  }
  return (
    <table className="table">
      <thead>
        <tr>
          <th>Tickets</th>
          <th>Boules</th>
          <th>Mises</th>
        </tr>
      </thead>
      <tbody>
        {_players}
        <tr className="button">
          <td />
          <td>
            <React.Fragment>
              <AddPlayerModal
                balls={balls}
                onSubmit={_onSubmit}
                limits={limits}
              />
            </React.Fragment>
          </td>
          <td />
        </tr>
      </tbody>
    </table>
  );
};
export default Players;
